import { type Message, MessageType } from 'shared-types/user';

interface OngoingOfferWithExpirationDate {
  type: MessageType.OngoingOffer;
  expirationDatetime: string;
}

export const isOngoingOfferWithExpirationDate = (
  message: Message | undefined,
): message is OngoingOfferWithExpirationDate =>
  !!(message && message?.type === MessageType.OngoingOffer && message.expirationDatetime);
